import {UserLevel} from '@netx/core-user-next/constants';
import {BrandPortalWatermarkPosition, type IBrandPortal} from './schema';

export const portalDefaults: Readonly<IBrandPortal> = {
	advancedSearchEnabled: true,
	attributeIds: [],
	attributes: [],
	carousel: [],
	category: 1,
	color1: '#4c516f',
	color2: null,
	contactMessage: '',
	copyright: '',
	disableWebfonts: false,
	displayCatDescriptions: false,
	enableSignIn: false,
	favicon: 0,
	font: 0,
	googleAnalyticsEnabled: false,
	googleAnalyticsId: '',
	group: 0,
	headerLinks: false,
	homeRoute: '',
	pageId: 0,
	id: 0,
	label: '',
	logo: 0,
	logoutUrl: '',
	name: '',
	path: '',
	properties: {
		name: '',
		homeRoute: '',
		menus: [],
		pages: [],
		templates: {
			template1: 'Template 1',
			template2: 'Template 2',
			template3: 'Template 3',
			template4: 'Template 4',
			template5: 'Template 5',
			template6: 'Template 6',
			template7: 'Template 7',
			template8: 'Template 8',
			template9: 'Template 9',
			template10: 'Template 10',
			template11: 'Template 11',
		},
		version: '',
	},
	requireLogin: true,
	searchPlaceholder: '',
	singleSignOnURL: '',
	ssoLoginEnabled: false,
	ssoLoginLabel: '',
	tagline: '',
	termsAndConditions: '',
	theme: 'clean',
	userLevel: UserLevel.NO_ACCESS,
	visible: true,
	watermark: 0,
	watermarkPos: BrandPortalWatermarkPosition.BOTTOM_LEFT,
};
